import UltMeta, { Meta } from "./UltMeta/index";

const APP_PREFIX = "ROLE_APPLICATION_";

class Applications extends UltMeta {
    // 查船
    FUND_SHIP_INFO = new Meta(APP_PREFIX + "FUND_SHIP_INFO", "船舶信息");
    FUND_SHIP_DYNAMIC_INFO = new Meta(APP_PREFIX + "FUND_SHIP_DYNAMIC_INFO", "船舶动态信息");
    FUND_SHIP_ROUTE_INFO = new Meta(APP_PREFIX + "FUND_SHIP_ROUTE_INFO", "船舶轨迹");
    FUND_SHIP_DEVICE_INFO = new Meta(APP_PREFIX + "FUND_SHIP_DEVICE_INFO", "船舶设备信息");
    // 查车
    FUND_CAR_INFO = new Meta(APP_PREFIX + "FUND_CAR_INFO", "车辆信息");
    FUND_CAR_DYNAMIC_INFO = new Meta(APP_PREFIX + "FUND_CAR_DYNAMIC_INFO", "车辆动态信息");
    FUND_CAR_ROUTE_INFO = new Meta(APP_PREFIX + "FUND_CAR_ROUTE_INFO", "车辆轨迹");
    FUND_CAR_DEVICE_INFO = new Meta(APP_PREFIX + "FUND_CAR_DEVICE_INFO", "车辆设备信息");
    // 摄像头
    CAMERA_LIVE = new Meta(APP_PREFIX + "CAMERA_LIVE", "直播");
    CAMERA_BACK_VIEW = new Meta(APP_PREFIX + "CAMERA_BACK_VIEW", "视频回放");
    // 船运需求
    SHIP_TRANSFER_PUSH_OWNER_REQUIREMENT = new Meta(
        APP_PREFIX + "SHIP_TRANSFER_PUSH_OWNER_REQUIREMENT",
        "推送货主找船需求"
    );

    SHIP_TRANSFER_PUSH_REQUIREMENT_PUBLISH = new Meta(
        APP_PREFIX + "SHIP_TRANSFER_PUSH_REQUIREMENT_PUBLISH",
        "推送船运需求发布"
    );
    SHIP_TRANSFER_CONNECT_REQUIREMENT = new Meta(APP_PREFIX + "SHIP_TRANSFER_CONNECT_REQUIREMENT", "接入找船需求");
    SHIP_TRANSFER_PUSH_REQUIREMENT_BILL = new Meta(APP_PREFIX + "SHIP_TRANSFER_PUSH_REQUIREMENT_BILL", "推送船运单");
    SHIP_TRANSFER_CONNECT_TRANSPORT_BILL = new Meta(APP_PREFIX + "SHIP_TRANSFER_CONNECT_TRANSPORT_BILL", "接入船运单");
    // OCR模型
    OCR_ID_CARD = new Meta(APP_PREFIX + "OCR_ID_CARD", "身份证");
    OCR_DRIVER_LICENSE = new Meta(APP_PREFIX + "OCR_DRIVER_LICENSE", "驾驶证");
    OCR_QUALIFICATION_CERTIFICATE = new Meta(APP_PREFIX + "OCR_QUALIFICATION_CERTIFICATE", "从业资格证");
    OCR_DRIVING_LICENSE = new Meta(APP_PREFIX + "OCR_DRIVING_LICENSE", "行驶证");
    OCR_ROAD_TRANSPORT_CERTIFICATE = new Meta(APP_PREFIX + "OCR_ROAD_TRANSPORT_CERTIFICATE", "道路运输证");
    OCR_BANK_CARD = new Meta(APP_PREFIX + "OCR_BANK_CARD", "银行卡");
}

export const APPLICATIONS = new Applications();
